"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var Grid_1 = __importDefault(require("@material-ui/core/Grid"));

var title_1 = __importDefault(require("./title"));

var Layout = function Layout(props) {
  return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(Grid_1.default, {
    item: true,
    xs: 6
  }, react_1.default.createElement(title_1.default, {
    title: props.title,
    type: "pageTitle"
  })), props.children);
};

exports.default = Layout;